import { CommonModule } from '@angular/common';
import { Component, Injectable, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { MiroBoard, MiroService } from '@mysrc/app/features/miro/services/miro.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { zip } from 'rxjs';
import { CacheService, StaffItem } from '../../../../../services/cache.service';
import { ApplicationItem, ApplicationLoginRequired } from '../../../applications/models/applicationItem';
import { ApplicationsService } from '../../../applications/services/application.service';
import { ExpertsItem } from '../../../ask-the-experts/models/ExpertsItem';
import { AskTheExpertService } from '../../../ask-the-experts/services/ask-the-expert.service';
import { AssessmentItem, AssessmentsService } from '../../../assessment/services/assessment.service';
import { IWorkspace } from '../../../assessment/services/workspace.service';
import { VideoModalComponent } from '../../../common/video-modal/video-modal.component';
import { SharepointPackageType } from '../../../sales-and-delivery/models/SharepointPackageType';
import { TaxonomyFilesComponent } from '../../../sales-and-delivery/taxonomy-files/taxonomy-files.component';
import { PinnedDiamondIp } from '../../../widgets/components/diamondip-tile/diamondip-tile.component';
import { ModalOptions, displayModalComponent } from '../../../widgets/models';
import { IPinnedTile, TileService } from '../../../widgets/services/tile.service';
import { TileContainerComponent } from '../../../widgets/tile-container/tile-container.component';
import { Tile } from '../../../widgets/tile/tile.component';
import { TaskListItem, TaskListService } from '../../services/tasklists.service';
import { PinnedDashboardComponent } from '../pinned-dashboard/pinned-dashboard.component';
import { PinnedPushToTeamsComponent } from '../pinned-push-to-teams/pinned-push-to-teams.component';
import { PinnedTileContainerComponent } from '../pinned-tile-container/pinned-tile-container.component';


@Injectable({
  providedIn: 'root'
})
@Component({
  selector: 'app-pinned-tiles',
  standalone: true,
  imports: [PinnedDashboardComponent, PinnedTileContainerComponent, FormsModule, CommonModule, TileContainerComponent, VideoModalComponent],
  templateUrl: './pinned-tiles.component.html',
  styleUrls: ['./pinned-tiles.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PinnedTilesComponent implements OnInit {
  @Input() tiles: Tile[] = [];
  tilesExpert: Tile[] = [];
  tilesMiro: Tile[] = [];
  tilesTasklists: Tile[] = [];
  tileAssessmentList: Tile[] = [];
  tileWorkspaceList: Tile[] = [];
  tileDiamondIpList: Tile[] = [];
  tileMiroboardList: Tile[] = [];
  pinnedTiles: IPinnedTile[] = [];
  currentUser!: StaffItem;
  experts: ExpertsItem[] = [];
  tasklists: TaskListItem[] = [];
  assessmentList: any[] = [];
  workspaceList: IWorkspace[] = [];
  diamondIpList: PinnedDiamondIp[] = [];
  miroBoardList: MiroBoard[] = [];
  showPopUp: boolean = false;
  teamFolderIdDetail: string = "";
  title: string = "My Pinned Items";
  tileColor: string = "secondary2";
  checkListtileColor: string = "secondary7";
  tileTitle: string = "Task List";
  checkListtileTitle: string = "Check List";
  constructor(private miroService: MiroService,private service: TileService, private cache: CacheService, private baseService: ApplicationsService, private router: Router, private route: ActivatedRoute, private expertService: AskTheExpertService, private taskListsService: TaskListService, private assessmentService: AssessmentsService, private modalService: NgbModal) {
  }
  async ngOnInit(): Promise<void> {
    this.service.getCurrentUser().then((data: any) => {
      this.currentUser = data;
      this.getPinnedData(data.emailAddress);
    });
  }

  getPinnedData(email:any) {
    zip(this.expertService.getAllItems(), /*this.taskListsService.getAllItems(),*/ this.service.getPinnedTiles(),
      this.service.getAssesmentListForUser(), /*this.service.getAllworkspaces()*/ this.service.getAllPinnedDiamondIp(),
      this.miroService.getMiroBoardsForUser(email)
    )

      .subscribe(([dataExpert,/* dataTaskLists,*/ dataPin, dataAssessment, /*dataWorkspace*/ dataDiamondIp,miroBoardUser]) => {
        this.experts = dataExpert;
        this.loadExpertItems();
        this.tilesExpert = this.getExpertTiles();
        //this.tasklists = dataTaskLists;
        this.loadTasklistsItems();
        this.tilesTasklists = this.getTasklistsTiles();
        this.pinnedTiles = dataPin;
        this.assessmentList = dataAssessment;
        this.loadAssessmentListItems();
        this.tileAssessmentList = this.getAssessmentListTiles();
        //this.workspaceList = dataWorkspace;
        this.loadWorkspaceListItems();
        this.tileWorkspaceList = this.getWorkspacetListTiles();
        this.diamondIpList = dataDiamondIp;
        this.loadDiamondIpListItems();
        this.tileDiamondIpList = this.getDiamondIpListTiles();
        this.miroBoardList = miroBoardUser;
        this.loadMiroBoardListItems();
        this.tileMiroboardList = this.getMiroBoardListTiles();
        dataPin.forEach(tile => {
          if (this.tilesExpert.filter(x => x.data.tile.id == tile.tileId).length > 0) {
            this.tiles.push(this.tilesExpert.filter(x => x.data.tile.id == tile.tileId)[0]);
          }
           if (this.tilesTasklists.filter(x => x.data.tile.id == tile.tileId).length > 0) {
            this.tiles.push(this.tilesTasklists.filter(x => x.data.tile.id == tile.tileId)[0]);
          }
          if (this.assessmentList.filter(x => x.assessmentList.uniqueId == tile.tileId).length > 0) {
            this.tiles.push(this.tileAssessmentList.filter(x => x.data.tile.id == tile.tileId)[0]);
          }
           if (this.workspaceList.filter(x => x.id == tile.tileId).length > 0) {
            this.tiles.push(this.tileWorkspaceList.filter(x => x.data.tile.id == tile.tileId)[0]);
          }
           if (this.diamondIpList.filter(x => x.packageId == tile.tileId).length > 0) {
            this.tiles.push(this.tileDiamondIpList.filter(x => x.data.packageId == tile.tileId)[0]);
          }
           if (this.miroBoardList.filter(x => x.miroId == tile.tileId).length > 0) {
             this.tiles.push(this.tileMiroboardList.filter(x => x.data.miroId == tile.tileId)[0]);
          }
        });
      })
  }


  // Expert

  loadExpertItems(): void {
    this.experts.forEach((expert) => {
      expert.tile = {
        color: "secondary4",
        type: "unset",
        title: "Ask The Experts",
        size: "xlarge",
        id: expert.id!,
        cssclass: "tilebutton",
        ispinned: true
      };
    });
  }

  getExpertTiles(): Tile[] {
    return this.experts.map((expert) => {
      var tile = expert.tile;
      tile.data = expert;
      return tile;
    });
  }


  // Tasklists


  loadTasklistsItems(): void {
    this.tasklists.forEach((tasklist) => {
      if (tasklist.checkList == false) {
        tasklist.tile = {
          color: this.tileColor,
          type: "unset",
          title: this.tileTitle,
          size: "small",
          id: tasklist.id!,
          cssclass: "tilebutton",
          ispinned: true,
        };
      }
      else if ((tasklist.checkList == true)) {
        tasklist.tile = {
          color: this.checkListtileColor,
          type: "unset",
          title: this.checkListtileTitle,
          size: "small",
          id: tasklist.id!,
          cssclass: "tilebutton",
          ispinned: true,
        };
      }

    });
  }
  getTasklistsTiles(): Tile[] {
    return this.tasklists.map((tasklist) => {
      var tile = tasklist.tile;
      tile.data = tasklist;
      return tile;
    });
  }
  // Assessment List


  loadAssessmentListItems(): void {
    this.assessmentList.forEach((assessment) => {
      assessment.tile = {
        color: "secondary6",
        type: "assessment",
        title: "Assessments",
        size: "small",
        id: assessment.assessmentList.uniqueId!,
        cssclass: "tilebutton",
        ispinned: true
      };
    });
  }
  getAssessmentListTiles(): Tile[] {
    return this.assessmentList.map((assessment) => {
      var tile = assessment.tile;
      tile.data = assessment;
      return tile;
    });
  }
  //workspace
  getWorkspacetListTiles(): Tile[] {
    return this.workspaceList.map((workspace) => {
      var tile = workspace.tile;
      tile.data = workspace;
      return tile;
    });
  }
  loadWorkspaceListItems(): void {
    this.workspaceList.forEach((workspace) => {
      workspace.tile = {
        color: "primary",
        type: "workspace",
        title: "Workspace",
        size: "small",
        id: workspace.id!,
        cssclass: "tilebutton",
        ispinned: true
      };
    });
  }
  //Diamond Ip
  getDiamondIpListTiles(): Tile[] {
    return this.diamondIpList.map((diamondIp) => {
      var tile: any = diamondIp.tile;
      tile.data = diamondIp;
      return tile;
    });
  }
  getMiroBoardListTiles(): Tile[] {
    return this.miroBoardList.map((miroboard) => {
      var tile: any = miroboard.tile;
      tile.data = miroboard;
      return tile;
    });
  }
  loadDiamondIpListItems(): void {
    this.diamondIpList.forEach((diamondIp) => {
      diamondIp.tile = {
        color: "secondary9",
        type: "Diamond IP",
        title: "Diamond IP",
        size: "small",
        id: diamondIp.packageId!,
        cssclass: "tilebutton",
        ispinned: true
      };
    });
  }
  loadMiroBoardListItems(): void {
    this.miroBoardList.forEach((miroboard) => {
      miroboard.tile = {
        color: "secondary",
        type: "Whiteboards",
        title: "Whiteboards",
        size: "xlarge",
        id: miroboard.miroId,
        cssclass: "tilebutton",
        ispinned: true
      };
    });
  }
  activateLink(application: ApplicationItem) {
    if (application.tile.type == "workspace") {
      this.service.getWorkspacesWithAssignedUsers(true).then((data) => {
        var workspaces: IWorkspace[] = [];
        workspaces = data;
        var currentWorkspace = workspaces.filter(x => x.id == application.id)[0];
        this.router.navigate(["workspace/" + currentWorkspace.id + "/" + currentWorkspace.lastActivityDisplay]);
      });
    }
    else if (application.tile.type == "assessment") {
      this.service.GetAssessmentDbData().then((data) => {
        var currentAssessment = data.filter(x => x.id == application.id)[0];
        const navigationExtras: NavigationExtras = {
          state: {
            surveyName: application.text
          }
        };
        this.router.navigate(["assessments/" + currentAssessment.surveyId], navigationExtras);
      });
    }
    else if (application.routerLink) {
      this.router.navigate([application.routerLink], { relativeTo: this.route });
    }
    else {
      if (application.loginRequired == ApplicationLoginRequired.PIResearch) {
        this.baseService.getPILink(this.currentUser.emailAddress, application.actionUrl).then(
          data => {
            window.open(data, '_blank', 'noreferrer');
          });
      }
      else if (application.surveyId != undefined) {
      }
      else {
        window.open(application.actionUrl, '_blank', 'noreferrer')
      }
    }
  }
  getTeamFolder(id: string) {
    var encodedPackageKey = encodeURIComponent(id).replace(/%/g, "!");
    this.service.getTeamViewFolder(encodedPackageKey).then(data => {
      this.teamFolderIdDetail = data.packageName;
      this.addNewTask(this.teamFolderIdDetail);
    });
  }
  downloadSharepointFiles(id: string, packageType: SharepointPackageType) {
    //(document.getElementsByClassName('workspace-spinner-folder')[0] as HTMLElement).style.display = 'block';
    this.service.downloadSharePointFiles(id, packageType).then(data => {
      const filename = data.fileName;
      this.downloadPDF(data.fileBinary, "application/vnd.openxmlformats", filename);
      // (document.getElementsByClassName('workspace-spinner-folder')[0] as HTMLElement).style.display = 'none';
    });
  }

  downloadPDF(data: any, type: any, filenName: string) {
    const linkSource = `data:${type};base64,${data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = filenName;
    downloadLink.click();
  }
  closePopUp(event: any) {
    this.showPopUp = false;

  }
  shortTileName(tileName: string) {

  }
  public addNewTask(teamFolderIdDetail: string) {
    let params: any[] = [];
    params.push({ 'teamFolderIdDetail': teamFolderIdDetail })
    params.push()
    let options: ModalOptions = {
      title: '',
      showSave: false,
      showCancel: true,
      showCross: false,
      showFullscreen: false,
    };
    displayModalComponent(PinnedPushToTeamsComponent, 'lg', options, this.modalService, params);
  }
  setTileTitle(key: string) {
    if (key.length > 15)
      return key.substring(0, 17) + ' ...';
    else
      return key;
  }
  setTileTitleForDiamondIp(key: string) {
    if (key.length > 50)
      return key.substring(0, 50) + ' ...';
    else
      return key;
  }
  viewTaxonomyFiles(id: string, packageType: SharepointPackageType, termName: string) {
    this.opendownloadfiles(id, packageType, termName);
  }
  opendownloadfiles(id: string, packageType: SharepointPackageType, termName: string) {
    let params: any[] = [];
    params.push({ 'id': id });
    params.push({ 'packageType': packageType });
    params.push({ 'termName': termName })
    const modalref = displayModalComponent(TaxonomyFilesComponent, 's', { title: "Files", showSave: false, showCancel: false, showYes: false, showNo: false, showCross: true, scrollable: true }, this.modalService, params).result.then(
      (result) => {
      });
  }
}
